<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngFor="let v of consulta?.lista; let i = index">
      <h2 class="d-flex subtitle subtitle-warning">
        <div class="w-100">{{i+1}}º OCORRÊNCIA RECALL</div>
        <div class="text-nowrap">{{v?.data || 'NÃO INFORMADO'}}</div>
      </h2>
      <div class="px-3 py-2">
        <div class="text-warning fw-500">Comunicado: </div>
        <div>{{v?.comunicado || 'NÃO INFORMADO'}}</div>
        <div class="text-warning fw-500 mt-3">Procedimento: </div>
        <div class="">{{v?.procedimento || 'NÃO INFORMADO'}}</div>
      </div>
    </ng-container>

  </ng-container>

</app-card-consulta>
